import { onCLS, onLCP, onTTFB, onINP, type Metric } from "web-vitals"
import * as Sentry from "@sentry/react"

/**
 * Report Core Web Vitals as custom Sentry measurements.
 *
 * @remarks
 * Each metric is attached to the active Sentry transaction so it
 * appears alongside performance data in the Sentry dashboard.
 * Metrics are skipped when no root span is present (e.g. when
 * Sentry is not initialized or no active transaction exists).
 */
export function reportWebVitals(): void {
  const report = (metric: Metric) => {
    const span = Sentry.getActiveSpan()
    const rootSpan = span ? Sentry.getRootSpan(span) : undefined
    if (rootSpan) {
      rootSpan.setAttribute(`web_vital.${metric.name}`, metric.value)
    }
  }

  onCLS(report)
  onLCP(report)
  onTTFB(report)
  onINP(report)
}
